import paths from '../../paths';
import { Translate } from '@above-the-treeline/localization';

const TopMenuItems = {
	HomeNav: {
		icon: 'home',
		iconClass: 'home-nav-icon',
		linkTo: paths.home(),
		label: <Translate id="home" />,
	},
	NotificationsNav: {
		icon: 'bell-o',
		iconClass: 'notification-nav-icon',
		linkTo: paths.notifications(),
		label: <Translate id="messages" />,
		badgeLeft: 43,
	},
	YourBooksNav: {
		icon: 'books',
		iconClass: 'yourbooks-nav-icon',
		linkTo: paths.yourBooks(),
		label: <Translate id="your_books" />,
	},
};

export default TopMenuItems;
